import { render, staticRenderFns } from "./DireksiList.vue?vue&type=template&id=16a7edf5"
import script from "./DireksiList.vue?vue&type=script&lang=js"
export * from "./DireksiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports